/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { CreateOrganizationActions, CreateOrganizationActionTypes } from './types';

export const openCreateOrganizationOverlay = (): CreateOrganizationActionTypes => ({
  type: CreateOrganizationActions.OPEN_CREATE_ORGANIZATION_OVERLAY,
});

export const closeCreateOrganizationOverlay = (): CreateOrganizationActionTypes => ({
  type: CreateOrganizationActions.CLOSE_CREATE_ORGANIZATION_OVERLAY,
});
